import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { pluck } from 'rxjs/operators';
const getSecondHandSupplyByPkMutation = gql`query get_second_hand_supply_by_pk($id: uuid!) {
  second_hand_supplies_by_pk(id: $id) {
    id
    image
    is_featured
    description
    dental_supplier_id
    dental_professional_id
    dental_practice_id
    created_at
    color
    buy_now_price
    bid_ends_at
    bid_starts_at
    more_images
    product_type
    paused_at
    paused_message
    price_unit
    product_status
    seo_metadata
    sku
    sold_out_at
    sold_out_message
    specifications
    starting_price
    status
    supply_brand_id
    supply_brand{
      id
      name
    }
    supply_category_id
    supply_category{
      id
      name
    }
    supply_sub_category_id
    supply_sub_category{
      id
      name
    }
    title
    type
    updated_at
    video
    winner_dental_supplier_id
    winner_dental_practice_id
    winner_dental_professional_id
    bid_price
    freight_charge
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSupplyByPkService {

  constructor(private apollo: Apollo) { }
  getSecondHandSupplyByPk(id: string): any {
    return this.apollo.use('external').query({
      query: getSecondHandSupplyByPkMutation,
      variables: {
        id
      }
    }).pipe(pluck('data', 'second_hand_supplies_by_pk'));
  }

}
